export function onEnterOrSpace(callback) {
    return function (event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            callback();
        }
    };
}
